module.exports = __webpack_public_path__ + "roadmaps-b860f767c11be72dc2ee054f0a8c3c26.webp";